module.exports = __webpack_public_path__ + "static/media/BBC.725f980d.png";